import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DiscountCouponService from "./Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import PermissionAccess from "../../PermissionAccess/Access.js";
import moment from "moment";
import { SensitiveText, useSensitiveInfo } from "../../context/SensitiveInfoContext";

const DoctorICHistoryModal = ({ show, onClose, doctorId, doctorName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authData } = PermissionAccess();
  const { requestUnlock } = useSensitiveInfo();
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (show) {
      requestUnlock();
    }
  }, [show, requestUnlock]);

  useEffect(() => {
    const load = async () => {
      if (!show || !doctorId) return;
      setLoading(true);
      try {
        const response = await DiscountCouponService.getDoctorICVerificationHistory(
          authData.sessionID,
          doctorId
        );
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
          return;
        }
        if (response.data.status) {
          setLogs(response.data.data || []);
        } else {
          Alerts.swalErrorAlert(response.data.message || t("Failed to load history"));
        }
      } catch (error) {
        setLoading(false);
        Alerts.swalErrorAlert(error?.message || t("Server Error, Please try again later."));
      }
    };
    load();
  }, [show, doctorId, authData.sessionID, navigate, t]);

  if (!show) return null;

  return (
    <div
      className="modal d-block mt-4"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <LoadingOverlay active={loading} spinner={<DNALoader />}>
            <div className="modal-header">
              <h5 className="modal-title">
                {t("View History")}
                {doctorName ? ` — ${doctorName}` : ""}
              </h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              {logs.length === 0 ? (
                <p className="text-muted mb-0">{t("No history found")}</p>
              ) : (
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>{t("Timestamp")}</th>
                      <th>{t("Action")}</th>
                      <th>{t("Status")}</th>
                      <th>{t("Reviewer")}</th>
                      <th>{t("Reason")}</th>
                      <th>{t("IC / OCR")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log) => (
                      <tr key={log._id}>
                        <td>
                          {log.datetime_added
                            ? moment(log.datetime_added).format("YYYY-MM-DD HH:mm:ss")
                            : "-"}
                        </td>
                        <td>{log.action || "-"}</td>
                        <td>
                          {(log.previous_status || "-") + " → " + (log.new_status || "-")}
                        </td>
                        <td>{log.reviewer_name || "-"}</td>
                        <td>{log.reason || "-"}</td>
                        <td>
                          <div>
                            <small>
                              {t("Entered")}: <SensitiveText value={log.medical_assistant_id || log.entered_ic} />
                            </small>
                          </div>
                          <div>
                            <small>
                              {t("OCR")}: <SensitiveText value={log.ocr_ic} />
                            </small>
                          </div>
                          <div>
                            <small>
                              {t("Matched")}:{" "}
                              {log.matched === true
                                ? t("Yes")
                                : log.matched === false
                                  ? t("No")
                                  : "-"}
                            </small>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-light" onClick={onClose}>
                {t("Close")}
              </button>
            </div>
          </LoadingOverlay>
        </div>
      </div>
    </div>
  );
};

export default DoctorICHistoryModal;
